/**
 * Tiny class-name joiner.
 *
 * Deliberately not `tailwind-merge` (no extra dependency): every component puts
 * the caller's `className` last, so a caller override wins by CSS source order.
 */
export type ClassValue = string | number | false | null | undefined | ClassValue[]

export function cn(...values: ClassValue[]): string {
  const out: string[] = []
  for (const value of values) {
    if (!value && value !== 0) continue
    if (Array.isArray(value)) {
      const nested = cn(...value)
      if (nested) out.push(nested)
    } else {
      out.push(String(value))
    }
  }
  return out.join(' ')
}
